export default __webpack_public_path__ + "6f2a39f2a7b4861f95fd28543ea40cda.png";